import { Stack } from "@mui/material";
import { useEffect, useState } from "react";


export default function Flex({children, justifyContent, alignItems, spacing, limit, sx}){

    const [direction, setDirection] = useState('row')

    useEffect(() => {

        const l = limit || 1000;

        const dir = () => window.innerWidth < l ? 'column' : 'row';

        window.addEventListener('resize', () => 
            setDirection(dir())
        )

        setDirection(dir())

    }, [limit])


    /*const jC = useMemo(() => direction === 'row' ? (justifyContent || 'start') : 'center'
    , [direction, justifyContent]);

    const aI = useMemo(() => direction === 'row' ? (alignItems || 'stretch') : 'center'
    , [direction, alignItems]);*/

    return <Stack 
        direction={direction}
        justifyContent={justifyContent}
        alignItems={alignItems}
        spacing={spacing}
        flexWrap='wrap'
        sx={sx || {}}
    >

        {children}

    </Stack>
}